import DelectoryResource from '../DelectoryResource';

const TenMinutes = 1000 * 60 * 60;

class InventoryRecords extends DelectoryResource {
  constructor(opts) {
    super(opts);

    this.stats = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/inventory_records/stats',
      cacheConfig: {
        browserOnly: false,
        genKey: (payload) => {
          return JSON.stringify(payload.payload); // Don't include auth credentials
        },
        ttl: TenMinutes
      }
    });

    this.inventoryRecord = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/inventory_records/inventory_record'
    });

    this.inventoryRecordBySupplierSku = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/inventory_records/inventory_record_by_supplier_sku'
    });

    this.list = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/inventory_records/list'
    });

    this.searchSuggestions = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/web/inventory_records/search_suggestions'
    });

    this.similarProducts = DelectoryResource.createEndpoint({
      authRequired: false,
      path: '/market/inventory/similar_products'
    });
  }
}

export default InventoryRecords;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/resources/InventoryRecords.js